import store from "../redux/app/store";

import {
  setToastVisibilityStatus,
  setToastType,
  setToastTitle,
  setToastMessage,
  setToastDuration,
} from "../redux/features/applicationState/applicationStateSlice";

const toastManager = (toastType, toastTitle, toastMessage, toastDuration) => {
  store.dispatch(setToastVisibilityStatus(true));
  toastType && store.dispatch(setToastType(toastType));
  toastTitle && store.dispatch(setToastTitle(toastTitle));
  toastMessage && store.dispatch(setToastMessage(toastMessage));
  store.dispatch(setToastDuration(toastDuration));
};

export default toastManager;
